import { apptT, formatAppt } from '../appointments/apptI18n';

export const accessT = {
  it: {
    myDocs: 'I miei documenti',
    newSince: 'Dal suo ultimo accesso del {date} sono arrivati {n} nuovi documenti:',
    newOne: 'Dal suo ultimo accesso del {date} è arrivato 1 nuovo documento:',
    newNone: 'Dal suo ultimo accesso del {date} non sono arrivati nuovi documenti.',
    newFirst: 'È il suo primo accesso: trova {n} documenti disponibili.',
    newFirstOne: 'È il suo primo accesso: trova 1 documento disponibile.',
    newBadge: 'Nuovo',
    identifyTitle: 'Identificazione sicura',
    identifyText: 'Inserisca il codice fiscale o la partita IVA registrati presso lo studio. Le invieremo un codice di verifica via email.',
    fiscalPh: 'Codice fiscale o partita IVA',
    send: 'Invia codice',
    otpText: 'Abbiamo inviato un codice a 6 cifre a {email}. Lo inserisca qui sotto (valido 10 minuti).',
    otpPh: 'Codice a 6 cifre',
    verify: 'Verifica',
    resend: 'Invia un nuovo codice',
    welcome: 'Benvenuto/a {name}. Sessione sicura attiva per 30 minuti.',
    noDocs: 'Al momento non ci sono documenti disponibili nella sua area.',
    download: 'Scarica',
    email: 'Invia via email',
    sentTo: 'Documento inviato a {email}',
    toPay: 'Copie da pagare',
    pay: 'Paga',
    logout: 'Chiudi sessione',
    notFound: 'Non abbiamo trovato un cliente con questi dati. Desidera richiedere l\'accesso all\'area riservata?',
    requestBtn: 'Richiedi accesso',
    retry: 'Riprova',
    reqTitle: 'Richiesta di accesso',
    name: 'Nome e cognome / Ragione sociale',
    emailPh: 'Email',
    phone: 'Telefono (facoltativo)',
    pratica: 'Numero pratica, se lo conosce (facoltativo)',
    privacy: 'Ho letto l\'informativa privacy e acconsento al trattamento dei dati per questa richiesta.',
    privacyLink: 'Informativa privacy',
    reqSend: 'Invia richiesta',
    reqDone: 'Grazie. La richiesta è stata inviata allo studio, che la verificherà. Se approvata, riceverà un\'email per impostare la password della sua area riservata.',
    cancel: 'Annulla',
    status: { aperta: 'Aperta', in_lavorazione: 'In lavorazione', da_firmare: 'Da firmare', completata: 'Completata', archiviata: 'Archiviata' },
    errors: {
      invalid_fiscal: 'Codice fiscale o partita IVA non valido.',
      wrong_code: 'Codice errato. Riprovi.',
      expired: 'Codice scaduto o troppi tentativi. Richieda un nuovo codice.',
      too_many: 'Troppi tentativi. Riprovi tra un\'ora o contatti lo studio.',
      session_expired: 'Sessione scaduta. Si identifichi di nuovo.',
      already_registered: 'Questi dati risultano già registrati: usi "I miei documenti" con il suo codice fiscale o contatti lo studio.',
      too_large: 'File troppo grande per l\'email: lo scarichi direttamente.',
      invalid_data: 'Compili tutti i campi obbligatori e accetti l\'informativa.',
      email_failed: 'Invio email non riuscito: scarichi il documento direttamente.',
      generic: 'Operazione non riuscita. Riprovi o contatti lo studio.',
    },
  },
  en: {
    myDocs: 'My documents',
    newSince: 'Since your last visit on {date}, {n} new documents have arrived:',
    newOne: 'Since your last visit on {date}, 1 new document has arrived:',
    newNone: 'No new documents have arrived since your last visit on {date}.',
    newFirst: 'This is your first visit: {n} documents are available.',
    newFirstOne: 'This is your first visit: 1 document is available.',
    newBadge: 'New',
    identifyTitle: 'Secure identification',
    identifyText: 'Enter the tax code or VAT number registered with the office. We will email you a verification code.',
    fiscalPh: 'Tax code or VAT number',
    send: 'Send code',
    otpText: 'We sent a 6-digit code to {email}. Enter it below (valid for 10 minutes).',
    otpPh: '6-digit code',
    verify: 'Verify',
    resend: 'Send a new code',
    welcome: 'Welcome {name}. Secure session active for 30 minutes.',
    noDocs: 'There are currently no documents available in your area.',
    download: 'Download',
    email: 'Send by email',
    sentTo: 'Document sent to {email}',
    toPay: 'Copies to pay',
    pay: 'Pay',
    logout: 'End session',
    notFound: 'We could not find a client with these details. Would you like to request access to the reserved area?',
    requestBtn: 'Request access',
    retry: 'Try again',
    reqTitle: 'Access request',
    name: 'Full name / Company name',
    emailPh: 'Email',
    phone: 'Phone (optional)',
    pratica: 'File number, if known (optional)',
    privacy: 'I have read the privacy notice and consent to the processing of my data for this request.',
    privacyLink: 'Privacy notice',
    reqSend: 'Send request',
    reqDone: 'Thank you. Your request has been sent to the office for review. If approved, you will receive an email to set the password for your reserved area.',
    cancel: 'Cancel',
    status: { aperta: 'Open', in_lavorazione: 'In progress', da_firmare: 'To be signed', completata: 'Completed', archiviata: 'Archived' },
    errors: {
      invalid_fiscal: 'Invalid tax code or VAT number.',
      wrong_code: 'Wrong code. Please try again.',
      expired: 'Code expired or too many attempts. Request a new code.',
      too_many: 'Too many attempts. Try again in an hour or contact the office.',
      session_expired: 'Session expired. Please identify yourself again.',
      already_registered: 'These details are already registered: use "My documents" with your tax code or contact the office.',
      too_large: 'File too large for email: please download it directly.',
      invalid_data: 'Fill in all required fields and accept the privacy notice.',
      email_failed: 'Email could not be sent: please download the document directly.',
      generic: 'Operation failed. Try again or contact the office.',
    },
  },
  de: {
    myDocs: 'Meine Dokumente',
    newSince: 'Seit Ihrem letzten Besuch am {date} sind {n} neue Dokumente eingegangen:',
    newOne: 'Seit Ihrem letzten Besuch am {date} ist 1 neues Dokument eingegangen:',
    newNone: 'Seit Ihrem letzten Besuch am {date} sind keine neuen Dokumente eingegangen.',
    newFirst: 'Dies ist Ihr erster Besuch: {n} Dokumente sind verfügbar.',
    newFirstOne: 'Dies ist Ihr erster Besuch: 1 Dokument ist verfügbar.',
    newBadge: 'Neu',
    identifyTitle: 'Sichere Identifizierung',
    identifyText: 'Geben Sie die beim Notariat registrierte Steuernummer oder USt-IdNr. ein. Wir senden Ihnen einen Bestätigungscode per E-Mail.',
    fiscalPh: 'Steuernummer oder USt-IdNr.',
    send: 'Code senden',
    otpText: 'Wir haben einen 6-stelligen Code an {email} gesendet. Geben Sie ihn unten ein (10 Minuten gültig).',
    otpPh: '6-stelliger Code',
    verify: 'Bestätigen',
    resend: 'Neuen Code senden',
    welcome: 'Willkommen {name}. Sichere Sitzung für 30 Minuten aktiv.',
    noDocs: 'Derzeit sind in Ihrem Bereich keine Dokumente verfügbar.',
    download: 'Herunterladen',
    email: 'Per E-Mail senden',
    sentTo: 'Dokument gesendet an {email}',
    toPay: 'Zu bezahlende Kopien',
    pay: 'Bezahlen',
    logout: 'Sitzung beenden',
    notFound: 'Wir haben keinen Mandanten mit diesen Daten gefunden. Möchten Sie Zugang zum geschützten Bereich beantragen?',
    requestBtn: 'Zugang beantragen',
    retry: 'Erneut versuchen',
    reqTitle: 'Zugangsantrag',
    name: 'Vor- und Nachname / Firma',
    emailPh: 'E-Mail',
    phone: 'Telefon (optional)',
    pratica: 'Aktennummer, falls bekannt (optional)',
    privacy: 'Ich habe die Datenschutzerklärung gelesen und willige in die Verarbeitung meiner Daten für diesen Antrag ein.',
    privacyLink: 'Datenschutzerklärung',
    reqSend: 'Antrag senden',
    reqDone: 'Vielen Dank. Ihr Antrag wurde zur Prüfung an das Notariat gesendet. Nach Freigabe erhalten Sie eine E-Mail, um das Passwort für Ihren Bereich festzulegen.',
    cancel: 'Abbrechen',
    status: { aperta: 'Offen', in_lavorazione: 'In Bearbeitung', da_firmare: 'Zu unterschreiben', completata: 'Abgeschlossen', archiviata: 'Archiviert' },
    errors: {
      invalid_fiscal: 'Ungültige Steuernummer oder USt-IdNr.',
      wrong_code: 'Falscher Code. Bitte erneut versuchen.',
      expired: 'Code abgelaufen oder zu viele Versuche. Fordern Sie einen neuen Code an.',
      too_many: 'Zu viele Versuche. Versuchen Sie es in einer Stunde erneut oder kontaktieren Sie das Notariat.',
      session_expired: 'Sitzung abgelaufen. Bitte erneut identifizieren.',
      already_registered: 'Diese Daten sind bereits registriert: Nutzen Sie "Meine Dokumente" mit Ihrer Steuernummer oder kontaktieren Sie das Notariat.',
      too_large: 'Datei zu groß für E-Mail: Bitte direkt herunterladen.',
      invalid_data: 'Füllen Sie alle Pflichtfelder aus und akzeptieren Sie die Datenschutzerklärung.',
      email_failed: 'E-Mail konnte nicht gesendet werden: Bitte laden Sie das Dokument direkt herunter.',
      generic: 'Vorgang fehlgeschlagen. Erneut versuchen oder Notariat kontaktieren.',
    },
  },
  fr: {
    myDocs: 'Mes documents',
    newSince: 'Depuis votre dernière visite du {date}, {n} nouveaux documents sont arrivés :',
    newOne: 'Depuis votre dernière visite du {date}, 1 nouveau document est arrivé :',
    newNone: 'Aucun nouveau document depuis votre dernière visite du {date}.',
    newFirst: 'C\'est votre première visite : {n} documents sont disponibles.',
    newFirstOne: 'C\'est votre première visite : 1 document est disponible.',
    newBadge: 'Nouveau',
    identifyTitle: 'Identification sécurisée',
    identifyText: 'Saisissez le code fiscal ou le numéro de TVA enregistré auprès de l\'étude. Nous vous enverrons un code de vérification par email.',
    fiscalPh: 'Code fiscal ou numéro de TVA',
    send: 'Envoyer le code',
    otpText: 'Nous avons envoyé un code à 6 chiffres à {email}. Saisissez-le ci-dessous (valable 10 minutes).',
    otpPh: 'Code à 6 chiffres',
    verify: 'Vérifier',
    resend: 'Envoyer un nouveau code',
    welcome: 'Bienvenue {name}. Session sécurisée active pendant 30 minutes.',
    noDocs: 'Aucun document n\'est disponible pour le moment dans votre espace.',
    download: 'Télécharger',
    email: 'Envoyer par email',
    sentTo: 'Document envoyé à {email}',
    toPay: 'Copies à payer',
    pay: 'Payer',
    logout: 'Fermer la session',
    notFound: 'Nous n\'avons trouvé aucun client avec ces données. Souhaitez-vous demander l\'accès à l\'espace réservé ?',
    requestBtn: 'Demander l\'accès',
    retry: 'Réessayer',
    reqTitle: 'Demande d\'accès',
    name: 'Nom et prénom / Raison sociale',
    emailPh: 'Email',
    phone: 'Téléphone (facultatif)',
    pratica: 'Numéro de dossier, si connu (facultatif)',
    privacy: 'J\'ai lu la politique de confidentialité et j\'accepte le traitement de mes données pour cette demande.',
    privacyLink: 'Politique de confidentialité',
    reqSend: 'Envoyer la demande',
    reqDone: 'Merci. Votre demande a été transmise à l\'étude pour vérification. Si elle est approuvée, vous recevrez un email pour définir le mot de passe de votre espace réservé.',
    cancel: 'Annuler',
    status: { aperta: 'Ouvert', in_lavorazione: 'En cours', da_firmare: 'À signer', completata: 'Terminé', archiviata: 'Archivé' },
    errors: {
      invalid_fiscal: 'Code fiscal ou numéro de TVA non valide.',
      wrong_code: 'Code erroné. Veuillez réessayer.',
      expired: 'Code expiré ou trop de tentatives. Demandez un nouveau code.',
      too_many: 'Trop de tentatives. Réessayez dans une heure ou contactez l\'étude.',
      session_expired: 'Session expirée. Veuillez vous identifier à nouveau.',
      already_registered: 'Ces données sont déjà enregistrées : utilisez "Mes documents" avec votre code fiscal ou contactez l\'étude.',
      too_large: 'Fichier trop volumineux pour l\'email : téléchargez-le directement.',
      invalid_data: 'Remplissez tous les champs obligatoires et acceptez la politique de confidentialité.',
      email_failed: 'L\'email n\'a pas pu être envoyé : téléchargez le document directement.',
      generic: 'Opération échouée. Réessayez ou contactez l\'étude.',
    },
  },
};

export const fmt = (s, vars) => Object.entries(vars).reduce((acc, [k, v]) => acc.replace(`{${k}}`, v), s);

const LOCALES = { it: 'it-IT', en: 'en-GB', de: 'de-DE', fr: 'fr-FR' };

export const newDocsSummary = (data, t, lang) => {
  const appt = data.next_appointment;
  const apptLine = appt ? `\n\n**${(apptT[lang] || apptT.it).title}:** ${formatAppt(appt.appuntamento, lang)}${appt.sede ? ` – ${appt.sede.name}` : ''}` : '';
  return docsSummary(data, t, lang) + apptLine;
};

const docsSummary = (data, t, lang) => {
  const docs = data.pratiche.flatMap((p) => p.documents.filter((d) => d.is_new).map((d) => `• **${d.name}** (${p.numero_pratica})`));
  if (!data.since) return docs.length === 1 ? t.newFirstOne : fmt(t.newFirst, { n: docs.length });
  const date = new Date(data.since).toLocaleDateString(LOCALES[lang] || 'it-IT', { day: 'numeric', month: 'long', year: 'numeric' });
  if (docs.length === 0) return fmt(t.newNone, { date });
  return `${fmt(docs.length === 1 ? t.newOne : t.newSince, { date, n: docs.length })}\n${docs.join('\n')}`;
};
